import { IPatientWaitingListState } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import useRouteInfo from "../../useRouteInfo";
import { useRouter } from "../../useRouter";
import { useAtHomeServicesListingAPI } from "../AtHomeServices/useAtHomeServicesListingAPI";

const useRefetchAtHomeListing = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("PATIENT_WAITING_LIST", "id"));
  const { atHomeListingFilters } = routeState.state as IPatientWaitingListState;
  const fetchAtHomeListing = useAtHomeServicesListingAPI();

  const execute = async () => {
    if (!atHomeListingFilters || Object.keys(atHomeListingFilters)?.length === 0) return;
    await fetchAtHomeListing(atHomeListingFilters);
  };

  return execute;
};

export default useRefetchAtHomeListing;
